import { createApp } from 'vue'
import App from './App.vue'
import Reader from './views/Reader.vue'
import { router } from './router'
import { recordLandingVisit } from './composables/useAnalytics'
import './styles/tokens.css'
import './styles/app.css'

// Portable-HTML (offline snapshot) mode: a downloaded reader template inlines
// the encrypted plan + key + comments into page globals (see reader-template/
// and useShare.buildPortableHtml). There is no server and the URL is a file://
// path, so we bypass the router and mount the Reader directly in embedded mode,
// where it decrypts the inlined payload instead of fetching from a slug.
const globals = window as unknown as { __REDLINE_PAYLOAD__?: string }
const payload = globals.__REDLINE_PAYLOAD__
const embedded =
  typeof payload === 'string' && payload.length > 0 && payload !== '---ENCRYPTED_PAYLOAD---'

if (embedded) {
  createApp(Reader, { embedded: true }).mount('#app')
} else {
  // Wait for the initial route to resolve before mounting, so a hard load of
  // /plan/<slug> hands Reader its `slug` prop at mount time. Mounting eagerly
  // races the async initial navigation — Reader's onMounted would see an empty
  // slug and never fetch the shared plan.
  // A hard load of the home page (not an in-app navigation back to it).
  if (location.pathname === '/') recordLandingVisit()
  const app = createApp(App).use(router)
  router.isReady().then(() => app.mount('#app'))
}
